import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {IdService} from "../id/id.service";

@Injectable()
export class AuthGuardService  {

    unauthorized$ = new Subject();

    constructor(
        private id: IdService
    ) {}

    canActivate() {
        if (this.id.loggedIn()) {
            return true;
        } else {
            this.unauthorized$.next(true);
            this.id.logout(location.href);
            return false;
        }
    }
}
